import React, { useEffect, useRef, useState } from 'react';
import styles from './ScrollToElement.module.scss';

interface ScrolltoElementProps {
  shouldFocus: boolean;
  resetState: () => void;
  children: React.ReactNode;
}


const ScrolltoElement: React.FC<ScrolltoElementProps> = ({ shouldFocus, children, resetState }) => {
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (shouldFocus && elementRef.current) {
      elementRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'end',
      });

      setTimeout(() => {
        if (elementRef.current) {
          elementRef.current.classList.add(styles.Animate);
          elementRef.current.addEventListener('animationend', () => {
            elementRef.current?.classList.remove(styles.Animate);
            resetState();
          }, { once: true });
        }
      }, 250);
    }
  }, [shouldFocus]);

  return (
      <div ref={elementRef} style={{'width': '90%', 'marginTop': '14px'}}>
        {children}
      </div>
  );
};

export default ScrolltoElement;
